import { render } from "./ModalWalletAddCredit.vue?vue&type=template&id=87a056de&scoped=true"
import script from "./ModalWalletAddCredit.vue?vue&type=script&lang=js"
export * from "./ModalWalletAddCredit.vue?vue&type=script&lang=js"

import "./ModalWalletAddCredit.vue?vue&type=style&index=0&id=87a056de&scoped=true&lang=css"

import exportComponent from "/media/dev/Develop/Projects/Sjef/kiosk.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87a056de"]])

export default __exports__